import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import pa from "./locales/pa.json";
import fil from "./locales/fil.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import pt from "./locales/pt.json";
import pl from "./locales/pl.json";
import de from "./locales/de.json";
import ar from "./locales/ar.json";

export const SUPPORTED_LANGUAGES = ["en", "pa", "fil", "es", "fr", "pt", "pl", "de", "ar"];
export const RTL_LANGUAGES = ["ar"];
export const DEFAULT_LANGUAGE = "en";
export const LANGUAGE_STORAGE_KEY = "klena.language";
export const LANGUAGE_LABELS = {
  en: "English", pa: "ਪੰਜਾਬੀ", fil: "Filipino", es: "Español", fr: "Français",
  pt: "Português", pl: "Polski", de: "Deutsch", ar: "العربية",
};

function isSupported(v) {
  return SUPPORTED_LANGUAGES.includes(v);
}

function getInitialLanguage() {
  const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return isSupported(stored) ? stored : DEFAULT_LANGUAGE;
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    pa: { translation: pa },
    fil: { translation: fil },
    es: { translation: es },
    fr: { translation: fr },
    pt: { translation: pt },
    pl: { translation: pl },
    de: { translation: de },
    ar: { translation: ar },
  },
  lng: getInitialLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES,
  defaultNS: "translation",
  // Natural-language English phrases are the keys, not dotted paths.
  keySeparator: false,
  nsSeparator: false,
  returnEmptyString: false,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

// Keep <html lang> in sync so the Gurmukhi font rule (:lang(pa)) applies.
function applyHtmlLang(lng) {
  if (typeof document === "undefined") return;
  document.documentElement.lang = lng;
  document.documentElement.dir = RTL_LANGUAGES.includes(lng) ? "rtl" : "ltr";
}
applyHtmlLang(i18n.language);
i18n.on("languageChanged", applyHtmlLang);

// Change language everywhere and remember it on this device.
export async function setLanguage(lng) {
  if (!isSupported(lng)) return;
  window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  await i18n.changeLanguage(lng);
}

export default i18n;
